var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"73e2b6aa9f2170e9659262e0ae2b3c6adad18cfc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"73e2b6aa9f2170e9659262e0ae2b3c6adad18cfc"};
      